export default "__VITE_ASSET__CCbMsVWo__"